import { getFlowInfo } from '@flows/src/api/getFlowInfo';
import { FLOWS_FINALIZE_PATH } from '@flows/src/FlowsFinalizeRouter';
import useFlowsInitNew from '@flows/src/hooks/init/useFlowsInitNew';
import useFlowsResetState from '@flows/src/hooks/useFlowsResetState';
import { AnvaFlowProduct } from '@sales-conversation/src/hooks/anva/useStartAnvaFlow';
import { useLocale } from '../../../../../i18n';

const useStartAnvaContractFlow = () => {
  const { initFlow } = useFlowsInitNew();
  const { userLang } = useLocale();
  const { reset } = useFlowsResetState();

  return async ({
    flowId,
    uuid,
    inputUrl,
    partyId,
    quoteId,
    quoteIds,
    anva_products,
  }: {
    flowId: string;
    anva_products: AnvaFlowProduct[];
    uuid?: string;
    inputUrl?: string;
    partyId?: string;
    quoteId?: string;
    quoteIds?: string[];
  }) => {
    reset();
    const flowInfo = await getFlowInfo(flowId, { lang: userLang });
    await initFlow({
      flowId: flowInfo.next!,
      payload: {
        party_id: partyId,
        anva_products,
        previous_session_id: uuid,
      },
      inputUrl,
      outputUrl: `${FLOWS_FINALIZE_PATH}/anva`,
      sessionId: uuid,
      shouldComplete: false,
    });
  };
};

export default useStartAnvaContractFlow;
